import css from 'styled-jsx/css';

const styles = css.global`#carros-eletricos-carregue {
  display: flex;
  padding-bottom: 32px;
  width: 90%;
  margin: 0 auto;
}

#carros-eletricos-carregue .ctn {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.carros-eletricos-carregue-contain {
  border-radius: 4px;
  border: 1px solid var(--black-cccccc, #CCC);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  margin-top: 40px;
  padding: 24px 16px;
}
.carros-eletricos-carregue-title {
  margin: 0;
  font-family: 'SantanderHeadline';
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: center;
  color: #444444;
  margin-bottom: 16px;
}

.carros-eletricos-carregue-title b {
  color: #cc0000;
  font-weight: 800!important;
}

.carros-eletricos-carregue-subtitle {
  font-family: 'SantanderHeadline';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  color: #444444;
  margin-bottom: 16px;
}

.carros-eletricos-carregue-subtitle b {
  font-weight: 900!important;
}

.carros-eletricos-carregue-itens-ctn {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 13px;
}

.carros-eletricos-carregue-itens-div {
  display: flex;
  flex-direction: column;
  gap: 13px;
}

.carros-eletricos-carregue-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.carros-eletricos-carregue-item-img {
  min-width: 24px;
  min-height: 24px;
  max-width: 24px;
  max-height: 24px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #cc0000;
  border-radius: 43px;
}

.carros-eletricos-carregue-item-img picture {
  display: flex;
  align-items: center;
  justify-content: center;
}

.carros-eletricos-carregue-item-img img {
  width: 14.4px;
  height: 14.4px;
  object-fit: contain;
}

.carros-eletricos-carregue-item-txt {
  font-family: 'SantanderText';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #444444;
}

.carros-eletricos-carregue-obs {
  font-family: 'SantanderHeadline';
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0px;
  text-align: center;
  color: #222;
  margin-top: 32px;
}

.carros-eletricos-carregue-obs b {
  color: #cc0000;
  font-weight: 500;
}

@media (min-width: 992px) {
  #carros-eletricos-carregue {
    padding-bottom: 40px;
    width: 100%;
    margin: 0 auto;
  }

  .carros-eletricos-carregue-contain {
    margin: 63px auto 0;
    padding: 24px 0;
    width: calc(100% - 40px);
  }

  .carros-eletricos-carregue-title {
    font-size: 32px;
    line-height: 48px;
    margin-bottom: 24px;
  }

  .carros-eletricos-carregue-subtitle {
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    margin: 0 auto 40px;
    max-width: 799px;
  }

  .carros-eletricos-carregue-itens-ctn {
    flex-direction: row;
    justify-content: center;
    gap: 80px;
  }

  .carros-eletricos-carregue-itens-div {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .carros-eletricos-carregue-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .carros-eletricos-carregue-item-img {
    min-width: 40px;
    min-height: 40px;
    max-width: 40px;
    max-height: 40px;
    width: 40px;
    height: 40px;
    border-radius: 40px;
  }

  .carros-eletricos-carregue-item-img img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .carros-eletricos-carregue-item-txt {
    font-size: 18px;
    line-height: 28px;
  }

  .carros-eletricos-carregue-obs {
    font-size: 32px;
    line-height: 48px;
    text-align: center;
    margin-top: 40px;
  }
}

`;

export default styles;